import React from 'react';

import FourTypesCarousel from './FourTypesCarousel';

import './styles.css';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { easeInOut } from 'popmotion';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '3.125rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  mainCont: {
    // background: 'linear-gradient(#FECCF4, #FBC143)',
    width: '51%'
  },
  textCont: {
    width: '87.5rem',
    padding: '2.5rem  '
  },
  insertTitle: {
    ...theme.extraFonts.insertTitle
  },
  horiLine: {
    height: '1px',
    width: '83px',
    color: 'black',
    backgroundColor: 'black',
    borderWidth: 0,
    marginTop: '1.875rem',
    marginBottom: '1.875rem',
    marginLeft: '45%'
  }
}));
console.log(useStyles.horiLine);

const FourTypes = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView();

  const renderer = (
    <>
      <Grid
        component={motion.div}
        initial={{ y: 50 }}
        animate={{ y: 0, transition: { duration: 1, delay: 0.2, ease: easeInOut } }}
        item
        style={{ marginTop: '2.5rem' }}
      >
        <Typography variant="h2">
          4 Types of Breast Cancer
          <sup style={{ fontFamily: 'proximaNovaReg', fontSize: '1rem' }} className={classes.sup}>
            3
          </sup>
        </Typography>
      </Grid>
      <Grid container className={classes.textCont}>
        <Grid
          component={motion.div}
          initial={{ y: 50 }}
          animate={{ y: 0, transition: { duration: 1, delay: 0.6, ease: easeInOut } }}
          container
          item
        >
          <Typography className={classes.insertTitle}>Invasive Ductal Carcinoma (IDC): </Typography>
          <Typography variant="body2" style={{ marginTop: '.5rem' }}>
            An invasive cancer where cancer cells initially formed in the milk ducts have spread
            into other parts of the breast tissue. This is the most common type of breast cancer,
            making up between 70 and 80% of diagnoses.
          </Typography>
          <hr className={classes.horiLine} />
        </Grid>
        <Grid
          component={motion.div}
          initial={{ y: 50 }}
          animate={{ y: 0, transition: { duration: 1, delay: 1, ease: easeInOut } }}
          container
          item
        >
          <Typography className={classes.insertTitle}>
            Triple-negative Breast Cancer (TNBC):
          </Typography>
          <Typography variant="body2" style={{ marginTop: '.5rem' }}>
            Estrogen, progesterone, and the HER-2/neu gene are the three most common receptors known
            to feed breast cancer growth. A diagnosis of triple-negative breast cancer means that
            the cancer cells have tested negative for these receptors, making it very difficult to
            treat. TNBC accounts for 15 to 20% of diagnoses.
            <sup
              style={{ fontFamily: 'proximaNovaReg', fontSize: '.8rem' }}
              className={classes.sup}
            >
              4
            </sup>{' '}
            This type of breast cancer is also more deadly for Black women, with a low, 14% 5-year
            relative survival rate based on NIH reports.
            <sup
              style={{ fontFamily: 'proximaNovaReg', fontSize: '.8rem' }}
              className={classes.sup}
            >
              5
            </sup>
          </Typography>
          <hr className={classes.horiLine} />
        </Grid>
        <Grid
          component={motion.div}
          initial={{ y: 50 }}
          animate={{ y: 0, transition: { duration: 1, delay: 1.4, ease: easeInOut } }}
          container
          item
        >
          <Typography className={classes.insertTitle}>Inflammatory Breast Cancer (IBC):</Typography>
          <Typography variant="body2">
            This type of breast cancer is an aggressive and rapidly-growing cancer in which cancer
            cells penetrate the skin and lymph vessels of the breast, often producing no distinct
            tumor or lump that can be felt within the breast. Symptoms begin to appear when the
            lymph vessels become blocked by the breast cancer cells, which can cause skin irritation
            with persistent itching and appearance similar to a bug bite. In other cases, the breast
            can become red and swollen, with the skin taking on a pitted “orange peel” like
            appearance, and can also cause changes to the nipple.
          </Typography>
          <hr className={classes.horiLine} />
        </Grid>
        <Grid
          component={motion.div}
          initial={{ y: 50 }}
          animate={{ y: 0, transition: { duration: 1, delay: 1.8, ease: easeInOut } }}
          container
          item
        >
          <Typography className={classes.insertTitle}>Metastatic Breast Cancer:</Typography>
          <Typography variant="body2">
            Also known as Stage 4 cancer, this type indicates the spread of cancer cells to the rest
            of the body, like the lungs, liver, bones, or the brain. This stage of cancer spreads
            due to the cancer cells invading nearby healthy cells, migrating through the bloodstream
            to other parts of the body, or via new tumor growth, to name a few steps.
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  return (
    <>
      {matchesSM ? <FourTypesCarousel /> : null}
      <Grid container justifyContent="center" className={classes.wrapper}>
        <Grid
          ref={ref}
          container
          justifyContent="center"
          className="animatedGradient"
          style={{ width: '51%' }}
        >
          {inView ? renderer : null}
        </Grid>
      </Grid>
    </>
  );
};

export default FourTypes;
